import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { savePaymentMethod } from "../actions/cartActions";
import CheckoutSteps from "../components/CkeckoutSteps";

const PAYMENT_OPTIONS = [
  {
    value: "PayPal",
    name: "PayPal o tarjeta de crédito",
    tag: "Recomendado",
    icon: "fab fa-cc-paypal",
  },
  {
    value: "Stripe",
    name: "Stripe",
    tag: "",
    icon: "fab fa-cc-stripe",
  },
];

const PaymentScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  if (!shippingAddress.address) {
    navigate("/shipping");
  }

  const [paymentMethod, setPaymentMethod] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate("/placeorder");
  };

  return (
    <>
      <CheckoutSteps />
      <style>{`
        .hadacy-payment {
          --cream: #f5efe1;
          --dark: #2a1f0c;
          --gold: #b58c2c;
          --gold-light: #d4a949;
          --muted: #8b7458;
          --card-bg: #fbf7ec;
          --recess: #ede3cf;
          --hairline: rgba(43, 31, 12, 0.12);
          max-width: 640px;
          margin: 0 auto;
          padding: 0 16px;
        }
        .hadacy-payment__head {
          text-align: center;
          margin-bottom: 28px;
        }
        .hadacy-payment__title {
          font-family: 'Cormorant Garamond', serif;
          font-weight: 500;
          font-size: 42px;
          color: var(--dark);
          margin: 0 0 8px;
          letter-spacing: -0.005em;
        }
        .hadacy-payment__rule {
          width: 48px;
          height: 1px;
          background: var(--gold);
          margin: 0 auto 14px;
          border: 0;
        }
        .hadacy-payment__lead {
          font-family: 'Jost', sans-serif;
          font-size: 13px;
          color: var(--muted);
          letter-spacing: 0.04em;
          margin: 0 auto;
          line-height: 1.6;
          max-width: 480px;
        }
        .hadacy-payment__options {
          display: grid;
          gap: 14px;
        }
        .hadacy-payment__option {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 18px 22px;
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: 'Jost', sans-serif;
          margin: 0;
        }
        .hadacy-payment__option:hover {
          border-color: var(--gold);
        }
        .hadacy-payment__option--selected {
          border-color: var(--gold);
          background: rgba(181, 140, 44, 0.06);
          box-shadow: 0 0 0 3px rgba(181, 140, 44, 0.10);
        }
        .hadacy-payment__radio {
          width: 18px;
          height: 18px;
          border-radius: 999px;
          border: 1.5px solid var(--hairline);
          background: var(--cream);
          flex: 0 0 auto;
          position: relative;
          transition: border-color 0.2s ease;
        }
        .hadacy-payment__option--selected .hadacy-payment__radio {
          border-color: var(--gold);
        }
        .hadacy-payment__option--selected .hadacy-payment__radio::after {
          content: "";
          position: absolute;
          inset: 3px;
          border-radius: 999px;
          background: var(--gold);
        }
        .hadacy-payment__option-icon {
          font-size: 24px;
          color: var(--muted);
          flex: 0 0 auto;
          width: 32px;
          text-align: center;
        }
        .hadacy-payment__option--selected .hadacy-payment__option-icon {
          color: var(--gold);
        }
        .hadacy-payment__option-name {
          font-size: 15px;
          font-weight: 500;
          color: var(--dark);
          flex: 1;
        }
        .hadacy-payment__option-tag {
          font-size: 10px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--gold);
          padding: 4px 10px;
          border: 1px solid var(--gold);
          border-radius: 999px;
          font-weight: 600;
        }
        .hadacy-payment__hint {
          font-family: 'Jost', sans-serif;
          font-size: 13px;
          color: var(--muted);
          font-style: italic;
          text-align: center;
          margin: 26px 0 0;
        }
        .hadacy-payment__cta {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 100%;
          margin-top: 26px;
          padding: 14px 24px;
          background: var(--dark);
          color: var(--cream);
          border: 1px solid var(--dark);
          border-radius: 999px;
          font-family: 'Jost', sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .hadacy-payment__cta:hover:not(:disabled) {
          background: var(--gold);
          border-color: var(--gold);
        }
        .hadacy-payment__cta:hover:not(:disabled) i {
          transform: translateX(4px);
        }
        .hadacy-payment__cta i { transition: transform 0.2s ease; }
        .hadacy-payment__cta:disabled {
          background: var(--recess);
          color: var(--muted);
          border-color: var(--hairline);
          cursor: not-allowed;
        }
      `}</style>

      <div className="hadacy-payment">
        <div className="hadacy-payment__head">
          <h1 className="hadacy-payment__title">Método de pago</h1>
          <hr className="hadacy-payment__rule" />
          <p className="hadacy-payment__lead">
            Elige cómo quieres pagar tu pedido.
          </p>
        </div>

        <Form onSubmit={submitHandler}>
          <div className="hadacy-payment__options">
            {PAYMENT_OPTIONS.map((opt) => (
              <label
                key={opt.value}
                className={
                  "hadacy-payment__option" +
                  (paymentMethod === opt.value
                    ? " hadacy-payment__option--selected"
                    : "")
                }
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={opt.value}
                  checked={paymentMethod === opt.value}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  style={{ display: "none" }}
                />
                <span className="hadacy-payment__radio" />
                <i
                  className={`hadacy-payment__option-icon ${opt.icon}`}
                  aria-hidden="true"
                />
                <span className="hadacy-payment__option-name">{opt.name}</span>
                {opt.tag && (
                  <span className="hadacy-payment__option-tag">{opt.tag}</span>
                )}
              </label>
            ))}
          </div>

          {paymentMethod ? (
            <button type="submit" className="hadacy-payment__cta">
              Continuar
              <i className="fas fa-arrow-right"></i>
            </button>
          ) : (
            <p className="hadacy-payment__hint">
              Por favor selecciona un método de pago para continuar.
            </p>
          )}
        </Form>
      </div>
    </>
  );
};

export default PaymentScreen;
